<template>
    <form @submit.prevent="onSubmit">
        <div class="form__row">
            <div class="form__item">
                <form-input type="email" label="E-mail" :v="$v" name="username" v-model="$v.username.$model" autofocus/>
            </div>
        </div>
        <div class="form__row">
            <div class="form__item">
                <form-input type="password" label="Heslo" :v="$v" name="password" v-model="$v.password.$model"/>
            </div>
        </div>
        <div class="form__row">
            <div class="form__item">
                <form-checkbox label="Zapamatovat" name="remember" :v="$v" v-model="remember"/>
            </div>
        </div>
        <div class="form__row z1">
            <div class="form__item">
                <custom-button type="submit" primary>
                    {{ processing ? 'Přihlašuji...' : 'Přihlásit se' }}
                </custom-button>
            </div>
        </div>
    </form>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import FormCheckbox from '../../../components/Form/Input/FormCheckbox';
import FormInput from '../../../components/Form/Input/FormInput';
import CustomButton from '../../../components/Button/CustomButton';

export default {
    components:  {
        CustomButton,
        FormInput,
        FormCheckbox
    },
    props:       {
        processing: {
            type:     Boolean,
            required: false,
            default:  () => false,
        }
    },
    data() {
        return {
            username: null,
            password: null,
            remember: false
        }
    },
    validations: {
        username: {required},
        password: {required}
    },
    methods:     {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const {username, password, remember} = this;
                this.$emit('o3-submit', {username, password, remember});
            }
        },
        reset() {
            this.username = null;
            this.password = null;
            this.remember = false
            this.$v.$reset();
        }
    }
}
</script>
